/**
 * Nexuma — Service Worker update notifier
 *
 * Watches `navigator.serviceWorker` for a new SW that has installed but is
 * waiting (a fresh deploy). Lets React components subscribe so the user can
 * see a "Përditëso aplikacionin" toast and apply it with one tap — no hard
 * refresh, no broken cache, no ghost flicker.
 */

const listeners = new Set();
let waitingWorker = null;
let initialised = false;

function emit() {
  const state = { hasUpdate: Boolean(waitingWorker) };
  listeners.forEach((fn) => {
    try { fn(state); } catch (_) {}
  });
}

export function subscribeUpdates(fn) {
  listeners.add(fn);
  try { fn({ hasUpdate: Boolean(waitingWorker) }); } catch (_) {}
  return () => listeners.delete(fn);
}

export function applyUpdate() {
  if (!waitingWorker) {
    window.location.reload();
    return;
  }
  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  // Reload once the new worker takes control
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });
}

export function initSWUpdate() {
  if (initialised || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  initialised = true;

  navigator.serviceWorker.getRegistration().then((reg) => {
    if (!reg) return;

    // A worker installed before this page loaded — surface it immediately.
    if (reg.waiting) {
      waitingWorker = reg.waiting;
      emit();
    }

    reg.addEventListener('updatefound', () => {
      const installing = reg.installing;
      if (!installing) return;
      installing.addEventListener('statechange', () => {
        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          waitingWorker = installing;
          emit();
        }
      });
    });
  }).catch(() => { /* registration may not exist yet — that's fine */ });
}
